import React, { useContext } from 'react';

// firebase
import firebase from 'firebase/app';
import 'firebase/auth';
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';

// config
import { Redirect } from 'react-router';
import firebaseUiConfig from '../../config/config-firebase-ui';
import { StoreContext } from '../../store/StoreProvider';
import act from '../../store/actions';

// commons code
import { isEmpty, getFormatUser } from '../../commons/utils';

const SignIn = () => {
	// eslint-disable-next-line no-unused-vars
	const [state, dispatch] = useContext(StoreContext);
	const { user } = state;

	firebaseUiConfig.callbacks = {
		signInSuccessWithAuthResult: (authResult, redirectUrl) => {
			const userInfo = getFormatUser(authResult.user);
			const { uid, displayName, email } = userInfo;
			if (uid && (displayName || email)) {
				dispatch({
					type: act.FIREBASE_LOGIN_USER,
					payload: userInfo,
				});
			}
			return false;
		},
	};

	//  center style
	const textAlign = { textAlign: 'center' };

	return isEmpty(user) ? (
		<React.Fragment>
			<h2 style={textAlign}>SignIn to Persian Tadhkira Project</h2>
			<StyledFirebaseAuth uiConfig={firebaseUiConfig} firebaseAuth={firebase.auth()} />
		</React.Fragment>
	) : (
		<Redirect to="/Map" />
	);
};

export default SignIn;
